import Yt from "react-dom";
var Kt = {}.toString, P = function(r) {
  return Kt.call(r).slice(8, -1);
}, Tr = Array.isArray || function(r) {
  return P(r) == "Array";
}, j = function(r) {
  return typeof r == "object" ? r !== null : typeof r == "function";
}, M = function(r) {
  if (r == null) throw TypeError("Can't call method on " + r);
  return r;
}, L = function(r) {
  return Object(M(r));
}, Jt = Math.ceil, Qt = Math.floor, hr = function(r) {
  return isNaN(r = +r) ? 0 : (r > 0 ? Qt : Jt)(r);
}, Xt = Math.min, $ = function(r) {
  return r > 0 ? Xt(hr(r), 9007199254740991) : 0;
}, kr = function(r, t) {
  if (!j(r)) return r;
  var e, n;
  if (t && typeof (e = r.toString) == "function" && !j(n = e.call(r)) || typeof (e = r.valueOf) == "function" && !j(n = e.call(r)) || !t && typeof (e = r.toString) == "function" && !j(n = e.call(r))) return n;
  throw TypeError("Can't convert object to primitive value");
}, m = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, I = !m(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), y = typeof window == "object" && window && window.Math == Math ? window : typeof self == "object" && self && self.Math == Math ? self : Function("return this")(), Ir = y.document, Zt = j(Ir) && j(Ir.createElement), St = function(r) {
  return Zt ? Ir.createElement(r) : {};
}, Ot = !I && !m(function() {
  return Object.defineProperty(St("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), O = function(r) {
  if (!j(r)) throw TypeError(String(r) + " is not an object");
  return r;
}, Wr = Object.defineProperty, k = { f: I ? Wr : function(r, t, e) {
  if (O(r), t = kr(t, !0), O(e), Ot) try {
    return Wr(r, t, e);
  } catch {
  }
  if ("get" in e || "set" in e) throw TypeError("Accessors not supported");
  return "value" in e && (r[t] = e.value), r;
} }, dr = function(r, t) {
  return { enumerable: !(1 & r), configurable: !(2 & r), writable: !(4 & r), value: t };
}, or = function(r, t, e) {
  var n = kr(t);
  n in r ? k.f(r, n, dr(0, e)) : r[n] = e;
};
function Et(r, t) {
  return r(t = { exports: {} }, t.exports), t.exports;
}
var ir, z, ur, _ = I ? function(r, t, e) {
  return k.f(r, t, dr(1, e));
} : function(r, t, e) {
  return r[t] = e, r;
}, Cr = function(r, t) {
  try {
    _(y, r, t);
  } catch {
    y[r] = t;
  }
  return t;
}, yr = Et(function(r) {
  var t = y["__core-js_shared__"] || Cr("__core-js_shared__", {});
  (r.exports = function(e, n) {
    return t[e] || (t[e] = n !== void 0 ? n : {});
  })("versions", []).push({ version: "3.0.1", mode: "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)" });
}), re = 0, te = Math.random(), wt = function(r) {
  return "Symbol(".concat(r === void 0 ? "" : r, ")_", (++re + te).toString(36));
}, Br = !m(function() {
  return !String(Symbol());
}), Hr = yr("wks"), zr = y.Symbol, x = function(r) {
  return Hr[r] || (Hr[r] = Br && zr[r] || (Br ? zr : wt)("Symbol." + r));
}, ee = x("species"), jt = function(r, t) {
  var e;
  return Tr(r) && (typeof (e = r.constructor) != "function" || e !== Array && !Tr(e.prototype) ? j(e) && (e = e[ee]) === null && (e = void 0) : e = void 0), new (e === void 0 ? Array : e)(t === 0 ? 0 : t);
}, ne = x("species"), Nr = function(r) {
  return !m(function() {
    var t = [];
    return (t.constructor = {})[ne] = function() {
      return { foo: 1 };
    }, t[r](Boolean).foo !== 1;
  });
}, Yr = {}.propertyIsEnumerable, Kr = Object.getOwnPropertyDescriptor, At = { f: Kr && !Yr.call({ 1: 2 }, 1) ? function(r) {
  var t = Kr(this, r);
  return !!t && t.enumerable;
} : Yr }, oe = "".split, mr = m(function() {
  return !Object("z").propertyIsEnumerable(0);
}) ? function(r) {
  return P(r) == "String" ? oe.call(r, "") : Object(r);
} : Object, X = function(r) {
  return mr(M(r));
}, ie = {}.hasOwnProperty, A = function(r, t) {
  return ie.call(r, t);
}, Jr = Object.getOwnPropertyDescriptor, _t = { f: I ? Jr : function(r, t) {
  if (r = X(r), t = kr(t, !0), Ot) try {
    return Jr(r, t);
  } catch {
  }
  if (A(r, t)) return dr(!At.f.call(r, t), r[t]);
} }, er = yr("native-function-to-string", Function.toString), Qr = y.WeakMap, ue = typeof Qr == "function" && /native code/.test(er.call(Qr)), Xr = yr("keys"), Fr = function(r) {
  return Xr[r] || (Xr[r] = wt(r));
}, Dr = {}, ce = y.WeakMap;
if (ue) {
  var N = new ce(), ae = N.get, fe = N.has, le = N.set;
  ir = function(r, t) {
    return le.call(N, r, t), t;
  }, z = function(r) {
    return ae.call(N, r) || {};
  }, ur = function(r) {
    return fe.call(N, r);
  };
} else {
  var W = Fr("state");
  Dr[W] = !0, ir = function(r, t) {
    return _(r, W, t), t;
  }, z = function(r) {
    return A(r, W) ? r[W] : {};
  }, ur = function(r) {
    return A(r, W);
  };
}
var cr = { set: ir, get: z, has: ur, enforce: function(r) {
  return ur(r) ? z(r) : ir(r, {});
}, getterFor: function(r) {
  return function(t) {
    var e;
    if (!j(t) || (e = z(t)).type !== r) throw TypeError("Incompatible receiver, " + r + " required");
    return e;
  };
} }, J = Et(function(r) {
  var t = cr.get, e = cr.enforce, n = String(er).split("toString");
  yr("inspectSource", function(o) {
    return er.call(o);
  }), (r.exports = function(o, i, u, c) {
    var a = !!c && !!c.unsafe, s = !!c && !!c.enumerable, v = !!c && !!c.noTargetGet;
    typeof u == "function" && (typeof i != "string" || A(u, "name") || _(u, "name", i), e(u).source = n.join(typeof i == "string" ? i : "")), o !== y ? (a ? !v && o[i] && (s = !0) : delete o[i], s ? o[i] = u : _(o, i, u)) : s ? o[i] = u : Cr(i, u);
  })(Function.prototype, "toString", function() {
    return typeof this == "function" && t(this).source || er.call(this);
  });
}), se = Math.max, pe = Math.min, Rt = function(r) {
  return function(t, e, n) {
    for (var o = X(t), i = $(o.length), u = function(c, a) {
      var s = hr(c);
      return s < 0 ? se(s + a, 0) : pe(s, a);
    }(n, i); i > u; u++) if (u in o && o[u] === e) return u || 0;
    return -1;
  };
}, ge = Rt(), Tt = function(r, t) {
  var e, n = X(r), o = 0, i = [];
  for (e in n) !A(Dr, e) && A(n, e) && i.push(e);
  for (; t.length > o; ) A(n, e = t[o++]) && (~ge(i, e) || i.push(e));
  return i;
}, ar = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"], ve = ar.concat("length", "prototype"), Gr = { f: Object.getOwnPropertyNames || function(r) {
  return Tt(r, ve);
} }, It = { f: Object.getOwnPropertySymbols }, Zr = y.Reflect, he = Zr && Zr.ownKeys || function(r) {
  var t = Gr.f(O(r)), e = It.f;
  return e ? t.concat(e(r)) : t;
}, de = function(r, t) {
  for (var e = he(t), n = k.f, o = _t.f, i = 0; i < e.length; i++) {
    var u = e[i];
    A(r, u) || n(r, u, o(t, u));
  }
}, ye = /#|\.prototype\./, Z = function(r, t) {
  var e = be[me(r)];
  return e == Se || e != xe && (typeof t == "function" ? m(t) : !!t);
}, me = Z.normalize = function(r) {
  return String(r).replace(ye, ".").toLowerCase();
}, be = Z.data = {}, xe = Z.NATIVE = "N", Se = Z.POLYFILL = "P", Pt = Z, Oe = _t.f, E = function(r, t) {
  var e, n, o, i, u, c = r.target, a = r.global, s = r.stat;
  if (e = a ? y : s ? y[c] || Cr(c, {}) : (y[c] || {}).prototype) for (n in t) {
    if (i = t[n], o = r.noTargetGet ? (u = Oe(e, n)) && u.value : e[n], !Pt(a ? n : c + (s ? "." : "#") + n, r.forced) && o !== void 0) {
      if (typeof i == typeof o) continue;
      de(i, o);
    }
    (r.sham || o && o.sham) && _(i, "sham", !0), J(e, n, i, r);
  }
}, Mt = x("isConcatSpreadable"), Ee = !m(function() {
  var r = [];
  return r[Mt] = !1, r.concat()[0] !== r;
}), we = Nr("concat"), je = function(r) {
  if (!j(r)) return !1;
  var t = r[Mt];
  return t !== void 0 ? !!t : Tr(r);
};
E({ target: "Array", proto: !0, forced: !Ee || !we }, { concat: function(r) {
  var t, e, n, o, i, u = L(this), c = jt(u, 0), a = 0;
  for (t = -1, n = arguments.length; t < n; t++) if (i = t === -1 ? u : arguments[t], je(i)) {
    if (a + (o = $(i.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");
    for (e = 0; e < o; e++, a++) e in i && or(c, a, i[e]);
  } else {
    if (a >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
    or(c, a++, i);
  }
  return c.length = a, c;
} });
var $r = function(r, t) {
  var e = [][r];
  return !e || !m(function() {
    e.call(null, t || function() {
      throw 1;
    }, 1);
  });
}, Ae = [].join, _e = mr != Object, Re = $r("join", ",");
E({ target: "Array", proto: !0, forced: _e || Re }, { join: function(r) {
  return Ae.call(X(this), r === void 0 ? "," : r);
} });
var Lt = function(r) {
  if (typeof r != "function") throw TypeError(String(r) + " is not a function");
  return r;
}, kt = function(r, t, e) {
  if (Lt(r), t === void 0) return r;
  switch (e) {
    case 0:
      return function() {
        return r.call(t);
      };
    case 1:
      return function(n) {
        return r.call(t, n);
      };
    case 2:
      return function(n, o) {
        return r.call(t, n, o);
      };
    case 3:
      return function(n, o, i) {
        return r.call(t, n, o, i);
      };
  }
  return function() {
    return r.apply(t, arguments);
  };
}, br = function(r, t) {
  var e = r == 1, n = r == 2, o = r == 3, i = r == 4, u = r == 6, c = r == 5 || u, a = jt;
  return function(s, v, f) {
    for (var l, g, p = L(s), h = mr(p), d = kt(v, f, 3), b = $(h.length), S = 0, w = e ? a(s, b) : n ? a(s, 0) : void 0; b > S; S++) if ((c || S in h) && (g = d(l = h[S], S, p), r)) {
      if (e) w[S] = g;
      else if (g) switch (r) {
        case 3:
          return !0;
        case 5:
          return l;
        case 6:
          return S;
        case 2:
          w.push(l);
      }
      else if (i) return !1;
    }
    return u ? -1 : o || i ? i : w;
  };
}, Te = br(1), Ie = Nr("map");
E({ target: "Array", proto: !0, forced: !Ie }, { map: function(r) {
  return Te(this, r, arguments[1]);
} });
var G = Object.keys || function(r) {
  return Tt(r, ar);
}, Pe = m(function() {
  G(1);
});
E({ target: "Object", stat: !0, forced: Pe }, { keys: function(r) {
  return G(L(r));
} });
var Me = Rt(), Ct = [].indexOf, rt = !!Ct && 1 / [1].indexOf(1, -0) < 0, Le = $r("indexOf");
E({ target: "Array", proto: !0, forced: rt || Le }, { indexOf: function(r) {
  return rt ? Ct.apply(this, arguments) || 0 : Me(this, r, arguments[1]);
} });
var tt = Gr.f, ke = {}.toString, et = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Ce = function(r) {
  return et && ke.call(r) == "[object Window]" ? function(t) {
    try {
      return tt(t);
    } catch {
      return et.slice();
    }
  }(r) : tt(X(r));
}, Ne = m(function() {
});
E({ target: "Object", stat: !0, forced: Ne }, { getOwnPropertyNames: Ce });
var Fe = [].forEach, De = br(0), Y = $r("forEach") ? function(r) {
  return De(this, r, arguments[1]);
} : Fe;
E({ target: "Array", proto: !0, forced: [].forEach != Y }, { forEach: Y });
var rr = Object.assign, nt = !rr || m(function() {
  var r = {}, t = {}, e = Symbol();
  return r[e] = 7, "abcdefghijklmnopqrst".split("").forEach(function(n) {
    t[n] = n;
  }), rr({}, r)[e] != 7 || G(rr({}, t)).join("") != "abcdefghijklmnopqrst";
}) ? function(r, t) {
  for (var e = L(r), n = arguments.length, o = 1, i = It.f, u = At.f; n > o; ) for (var c, a = mr(arguments[o++]), s = i ? G(a).concat(i(a)) : G(a), v = s.length, f = 0; v > f; ) u.call(a, c = s[f++]) && (e[c] = a[c]);
  return e;
} : rr;
E({ target: "Object", stat: !0, forced: Object.assign !== nt }, { assign: nt });
for (var Ge in { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 }) {
  var ot = y[Ge], tr = ot && ot.prototype;
  if (tr && tr.forEach !== Y) try {
    _(tr, "forEach", Y);
  } catch {
    tr.forEach = Y;
  }
}
var $e = br(2), Ve = Nr("filter");
E({ target: "Array", proto: !0, forced: !Ve }, { filter: function(r) {
  return $e(this, r, arguments[1]);
} });
var Nt = x("iterator"), Ft = !1;
try {
  var qe = 0;
  ({ next: function() {
    return { done: !!qe++ };
  }, return: function() {
    Ft = !0;
  } })[Nt] = function() {
    return this;
  };
} catch {
}
var Ue = function(r, t, e, n) {
  try {
    return n ? t(O(e)[0], e[1]) : t(e);
  } catch (i) {
    var o = r.return;
    throw o !== void 0 && O(o.call(r)), i;
  }
}, fr = {}, We = x("iterator"), Be = Array.prototype, He = x("toStringTag"), ze = P(/* @__PURE__ */ function() {
  return arguments;
}()) == "Arguments", Ye = x("iterator"), Ke = function(r) {
  if (r != null) return r[Ye] || r["@@iterator"] || fr[function(t) {
    var e, n, o;
    return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (n = function(i, u) {
      try {
        return i[u];
      } catch {
      }
    }(e = Object(t), He)) == "string" ? n : ze ? P(e) : (o = P(e)) == "Object" && typeof e.callee == "function" ? "Arguments" : o;
  }(r)];
}, Je = !function(r, t) {
  if (!Ft) return !1;
  var e = !1;
  try {
    var n = {};
    n[Nt] = function() {
      return { next: function() {
        return { done: e = !0 };
      } };
    }, r(n);
  } catch {
  }
  return e;
}(function(r) {
});
E({ target: "Array", stat: !0, forced: Je }, { from: function(r) {
  var t, e, n, o, i, u = L(r), c = typeof this == "function" ? this : Array, a = arguments.length, s = a > 1 ? arguments[1] : void 0, v = s !== void 0, f = 0, l = Ke(u);
  if (v && (s = kt(s, a > 2 ? arguments[2] : void 0, 2)), l != null && (c != Array || (i = l) === void 0 || fr.Array !== i && Be[We] !== i)) for (o = l.call(u), e = new c(); !(n = o.next()).done; f++) or(e, f, v ? Ue(o, s, [n.value, f], !0) : n.value);
  else for (e = new c(t = $(u.length)); t > f; f++) or(e, f, v ? s(u[f], f) : u[f]);
  return e.length = f, e;
} });
var D, it, ut, Dt = function(r, t, e) {
  var n, o, i = String(M(r)), u = hr(t), c = i.length;
  return u < 0 || u >= c ? e ? "" : void 0 : (n = i.charCodeAt(u)) < 55296 || n > 56319 || u + 1 === c || (o = i.charCodeAt(u + 1)) < 56320 || o > 57343 ? e ? i.charAt(u) : n : e ? i.slice(u, u + 2) : o - 56320 + (n - 55296 << 10) + 65536;
}, Qe = !m(function() {
  function r() {
  }
  return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), ct = Fr("IE_PROTO"), Xe = Object.prototype, lr = Qe ? Object.getPrototypeOf : function(r) {
  return r = L(r), A(r, ct) ? r[ct] : typeof r.constructor == "function" && r instanceof r.constructor ? r.constructor.prototype : r instanceof Object ? Xe : null;
}, at = x("iterator"), Gt = !1;
[].keys && ("next" in (ut = [].keys()) ? (it = lr(lr(ut))) !== Object.prototype && (D = it) : Gt = !0), D == null && (D = {}), A(D, at) || _(D, at, function() {
  return this;
});
var Vr = { IteratorPrototype: D, BUGGY_SAFARI_ITERATORS: Gt }, Ze = I ? Object.defineProperties : function(r, t) {
  O(r);
  for (var e, n = G(t), o = n.length, i = 0; o > i; ) k.f(r, e = n[i++], t[e]);
  return r;
}, ft = y.document, rn = ft && ft.documentElement, $t = Fr("IE_PROTO"), xr = function() {
}, nr = function() {
  var r, t = St("iframe"), e = ar.length;
  for (t.style.display = "none", rn.appendChild(t), t.src = "javascript:", (r = t.contentWindow.document).open(), r.write("<script>document.F=Object<\/script>"), r.close(), nr = r.F; e--; ) delete nr.prototype[ar[e]];
  return nr();
}, Vt = Object.create || function(r, t) {
  var e;
  return r !== null ? (xr.prototype = O(r), e = new xr(), xr.prototype = null, e[$t] = r) : e = nr(), t === void 0 ? e : Ze(e, t);
};
Dr[$t] = !0;
var tn = k.f, lt = x("toStringTag"), st = function(r, t, e) {
  r && !A(r = e ? r : r.prototype, lt) && tn(r, lt, { configurable: !0, value: t });
}, en = Vr.IteratorPrototype, nn = function() {
  return this;
}, sr = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var r, t = !1, e = {};
  try {
    (r = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e, []), t = e instanceof Array;
  } catch {
  }
  return function(n, o) {
    return function(i, u) {
      if (O(i), !j(u) && u !== null) throw TypeError("Can't set " + String(u) + " as a prototype");
    }(n, o), t ? r.call(n, o) : n.__proto__ = o, n;
  };
}() : void 0), B = x("iterator"), Sr = Vr.IteratorPrototype, pt = Vr.BUGGY_SAFARI_ITERATORS, on = function() {
  return this;
}, un = cr.set, cn = cr.getterFor("String Iterator");
(function(r, t, e, n, o, i, u) {
  (function(p, h, d) {
    var b = h + " Iterator";
    p.prototype = Vt(en, { next: dr(1, d) }), st(p, b, !1), fr[b] = nn;
  })(e, t, n);
  var c, a = function(p) {
    if (l) return l;
    if (!pt && p in v) return v[p];
    switch (p) {
      case "keys":
      case "values":
      case "entries":
        return function() {
          return new e(this, p);
        };
    }
    return function() {
      return new e(this);
    };
  }, s = t + " Iterator", v = r.prototype, f = v[B] || v["@@iterator"] || o, l = !pt && f || a(o), g = f;
  g && (c = lr(g.call(new r())), Sr !== Object.prototype && c.next && (lr(c) !== Sr && (sr ? sr(c, Sr) : typeof c[B] != "function" && _(c, B, on)), st(c, s, !0))), v[B] !== l && _(v, B, l), fr[t] = l;
})(String, "String", function(r) {
  un(this, { type: "String Iterator", string: String(r), index: 0 });
}, function() {
  var r, t = cn(this), e = t.string, n = t.index;
  return n >= e.length ? { value: void 0, done: !0 } : (r = Dt(e, n, !0), t.index += r.length, { value: r, done: !1 });
});
var qr = function() {
  var r = O(this), t = "";
  return r.global && (t += "g"), r.ignoreCase && (t += "i"), r.multiline && (t += "m"), r.unicode && (t += "u"), r.sticky && (t += "y"), t;
}, pr = RegExp.prototype.exec, an = String.prototype.replace, qt = pr, Or = function() {
  var r = /a/, t = /b*/g;
  return pr.call(r, "a"), pr.call(t, "a"), r.lastIndex !== 0 || t.lastIndex !== 0;
}(), Er = /()??/.exec("")[1] !== void 0;
(Or || Er) && (qt = function(r) {
  var t, e, n, o, i = this;
  return Er && (e = new RegExp("^" + i.source + "$(?!\\s)", qr.call(i))), Or && (t = i.lastIndex), n = pr.call(i, r), Or && n && (i.lastIndex = i.global ? n.index + n[0].length : t), Er && n && n.length > 1 && an.call(n[0], e, function() {
    for (o = 1; o < arguments.length - 2; o++) arguments[o] === void 0 && (n[o] = void 0);
  }), n;
});
var Q = qt;
E({ target: "RegExp", proto: !0, forced: /./.exec !== Q }, { exec: Q });
var Ut = function(r, t, e) {
  return t + (e ? Dt(r, t, !0).length : 1);
}, Pr = function(r, t) {
  var e = r.exec;
  if (typeof e == "function") {
    var n = e.call(r, t);
    if (typeof n != "object") throw TypeError("RegExp exec method returned something other than an Object or null");
    return n;
  }
  if (P(r) !== "RegExp") throw TypeError("RegExp#exec called on incompatible receiver");
  return Q.call(r, t);
}, fn = x("species"), ln = !m(function() {
  var r = /./;
  return r.exec = function() {
    var t = [];
    return t.groups = { a: "7" }, t;
  }, "".replace(r, "$<a>") !== "7";
}), sn = !m(function() {
  var r = /(?:)/, t = r.exec;
  r.exec = function() {
    return t.apply(this, arguments);
  };
  var e = "ab".split(r);
  return e.length !== 2 || e[0] !== "a" || e[1] !== "b";
}), Wt = function(r, t, e, n) {
  var o = x(r), i = !m(function() {
    var f = {};
    return f[o] = function() {
      return 7;
    }, ""[r](f) != 7;
  }), u = i && !m(function() {
    var f = !1, l = /a/;
    return l.exec = function() {
      return f = !0, null;
    }, r === "split" && (l.constructor = {}, l.constructor[fn] = function() {
      return l;
    }), l[o](""), !f;
  });
  if (!i || !u || r === "replace" && !ln || r === "split" && !sn) {
    var c = /./[o], a = e(o, ""[r], function(f, l, g, p, h) {
      return l.exec === Q ? i && !h ? { done: !0, value: c.call(l, g, p) } : { done: !0, value: f.call(g, l, p) } : { done: !1 };
    }), s = a[0], v = a[1];
    J(String.prototype, r, s), J(RegExp.prototype, o, function(f, l) {
      return v.call(f, this, l);
    }), n && _(RegExp.prototype[o], "sham", !0);
  }
}, pn = Math.max, gn = Math.min, vn = Math.floor, hn = /\$([$&`']|\d\d?|<[^>]*>)/g, dn = /\$([$&`']|\d\d?)/g;
Wt("replace", 2, function(r, t, e) {
  return [function(o, i) {
    var u = M(this), c = o == null ? void 0 : o[r];
    return c !== void 0 ? c.call(o, u, i) : t.call(String(u), o, i);
  }, function(o, i) {
    var u = e(t, o, this, i);
    if (u.done) return u.value;
    var c = O(o), a = String(this), s = typeof i == "function";
    s || (i = String(i));
    var v = c.global;
    if (v) {
      var f = c.unicode;
      c.lastIndex = 0;
    }
    for (var l = []; ; ) {
      var g = Pr(c, a);
      if (g === null || (l.push(g), !v)) break;
      String(g[0]) === "" && (c.lastIndex = Ut(a, $(c.lastIndex), f));
    }
    for (var p, h = "", d = 0, b = 0; b < l.length; b++) {
      g = l[b];
      for (var S = String(g[0]), w = pn(gn(hr(g.index), a.length), 0), V = [], q = 1; q < g.length; q++) V.push((p = g[q]) === void 0 ? p : String(p));
      var C = g.groups;
      if (s) {
        var U = [S].concat(V, w, a);
        C !== void 0 && U.push(C);
        var Ur = String(i.apply(void 0, U));
      } else Ur = n(S, a, w, V, C, i);
      w >= d && (h += a.slice(d, w) + Ur, d = w + S.length);
    }
    return h + a.slice(d);
  }];
  function n(o, i, u, c, a, s) {
    var v = u + o.length, f = c.length, l = dn;
    return a !== void 0 && (a = L(a), l = hn), t.call(s, l, function(g, p) {
      var h;
      switch (p.charAt(0)) {
        case "$":
          return "$";
        case "&":
          return o;
        case "`":
          return i.slice(0, u);
        case "'":
          return i.slice(v);
        case "<":
          h = a[p.slice(1, -1)];
          break;
        default:
          var d = +p;
          if (d === 0) return g;
          if (d > f) {
            var b = vn(d / 10);
            return b === 0 ? g : b <= f ? c[b - 1] === void 0 ? p.charAt(1) : c[b - 1] + p.charAt(1) : g;
          }
          h = c[d - 1];
      }
      return h === void 0 ? "" : h;
    });
  }
});
var yn = x("match"), Bt = function(r) {
  var t;
  return j(r) && ((t = r[yn]) !== void 0 ? !!t : P(r) == "RegExp");
}, mn = x("species"), bn = [].push, xn = Math.min, F = !m(function() {
  return !RegExp(4294967295, "y");
});
Wt("split", 2, function(r, t, e) {
  var n;
  return n = "abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(o, i) {
    var u = String(M(this)), c = i === void 0 ? 4294967295 : i >>> 0;
    if (c === 0) return [];
    if (o === void 0) return [u];
    if (!Bt(o)) return t.call(u, o, c);
    for (var a, s, v, f = [], l = (o.ignoreCase ? "i" : "") + (o.multiline ? "m" : "") + (o.unicode ? "u" : "") + (o.sticky ? "y" : ""), g = 0, p = new RegExp(o.source, l + "g"); (a = Q.call(p, u)) && !((s = p.lastIndex) > g && (f.push(u.slice(g, a.index)), a.length > 1 && a.index < u.length && bn.apply(f, a.slice(1)), v = a[0].length, g = s, f.length >= c)); ) p.lastIndex === a.index && p.lastIndex++;
    return g === u.length ? !v && p.test("") || f.push("") : f.push(u.slice(g)), f.length > c ? f.slice(0, c) : f;
  } : "0".split(void 0, 0).length ? function(o, i) {
    return o === void 0 && i === 0 ? [] : t.call(this, o, i);
  } : t, [function(o, i) {
    var u = M(this), c = o == null ? void 0 : o[r];
    return c !== void 0 ? c.call(o, u, i) : n.call(String(u), o, i);
  }, function(o, i) {
    var u = e(n, o, this, i, n !== t);
    if (u.done) return u.value;
    var c = O(o), a = String(this), s = function(V, q) {
      var C, U = O(V).constructor;
      return U === void 0 || (C = O(U)[mn]) == null ? q : Lt(C);
    }(c, RegExp), v = c.unicode, f = (c.ignoreCase ? "i" : "") + (c.multiline ? "m" : "") + (c.unicode ? "u" : "") + (F ? "y" : "g"), l = new s(F ? c : "^(?:" + c.source + ")", f), g = i === void 0 ? 4294967295 : i >>> 0;
    if (g === 0) return [];
    if (a.length === 0) return Pr(l, a) === null ? [a] : [];
    for (var p = 0, h = 0, d = []; h < a.length; ) {
      l.lastIndex = F ? h : 0;
      var b, S = Pr(l, F ? a : a.slice(h));
      if (S === null || (b = xn($(l.lastIndex + (F ? 0 : h)), a.length)) === p) h = Ut(a, h, v);
      else {
        if (d.push(a.slice(p, h)), d.length === g) return d;
        for (var w = 1; w <= S.length - 1; w++) if (d.push(S[w]), d.length === g) return d;
        h = p = b;
      }
    }
    return d.push(a.slice(p)), d;
  }];
}, !F);
var gr = `	
\v\f\r                　\u2028\u2029\uFEFF`, vr = "[" + gr + "]", Sn = RegExp("^" + vr + vr + "*"), On = RegExp(vr + vr + "*$"), Ht = function(r, t) {
  return r = String(M(r)), r = r.replace(Sn, ""), r = r.replace(On, ""), r;
}, wr = y.parseFloat, gt = 1 / wr(gr + "-0") != -1 / 0 ? function(r) {
  var t = Ht(String(r)), e = wr(t);
  return e === 0 && t.charAt(0) == "-" ? -0 : e;
} : wr;
E({ global: !0, forced: parseFloat != gt }, { parseFloat: gt });
var H, En = (H = "trim", m(function() {
  return !!gr[H]() || "​᠎"[H]() != "​᠎" || gr[H].name !== H;
}));
E({ target: "String", proto: !0, forced: En }, { trim: function() {
  return Ht(this);
} });
var Mr = x("unscopables"), Lr = Array.prototype;
Lr[Mr] == null && _(Lr, Mr, Vt(null));
var vt, wn = br(5), ht = !0;
"find" in [] && Array(1).find(function() {
  ht = !1;
}), E({ target: "Array", proto: !0, forced: ht }, { find: function(r) {
  return wn(this, r, arguments.length > 1 ? arguments[1] : void 0);
} }), vt = "find", Lr[Mr][vt] = !0;
var jr = y, dt = function(r) {
  return typeof r == "function" ? r : void 0;
}, yt = x("species"), jn = x("match"), An = k.f, _n = Gr.f, R = y.RegExp, Ar = R.prototype, K = /a/g, _r = /a/g, mt = new R(K) !== K;
if (Pt("RegExp", I && (!mt || m(function() {
  return _r[jn] = !1, R(K) != K || R(_r) == _r || R(K, "i") != "/a/i";
})))) {
  for (var T = function(r, t) {
    var e, n, o, i, u = this instanceof T, c = Bt(r), a = t === void 0;
    return !u && c && r.constructor === T && a ? r : (e = mt ? new R(c && !a ? r.source : r, t) : R((c = r instanceof T) ? r.source : r, c && a ? qr.call(r) : t), n = T, (i = (u ? this : Ar).constructor) !== n && typeof i == "function" && (o = i.prototype) !== n.prototype && j(o) && sr && sr(e, o), e);
  }, Rn = function(r) {
    r in T || An(T, r, { configurable: !0, get: function() {
      return R[r];
    }, set: function(t) {
      R[r] = t;
    } });
  }, bt = _n(R), xt = 0; xt < bt.length; ) Rn(bt[xt++]);
  Ar.constructor = T, T.prototype = Ar, J(y, "RegExp", T);
}
(function(r) {
  var t = function(n, o) {
    return arguments.length < 2 ? dt(jr[n]) || dt(y[n]) : jr[n] && jr[n][o] || y[n] && y[n][o];
  }(r), e = k.f;
  I && t && !t[yt] && e(t, yt, { configurable: !0, get: function() {
    return this;
  } });
})("RegExp");
var zt = /./.toString, Tn = m(function() {
  return zt.call({ source: "a", flags: "b" }) != "/a/b";
}), In = zt.name != "toString";
(Tn || In) && J(RegExp.prototype, "toString", function() {
  var r = O(this);
  return "/".concat(r.source, "/", "flags" in r ? r.flags : !I && r instanceof RegExp ? qr.call(r) : void 0);
}, { unsafe: !0 });
var Rr = Yt;
process.env.NODE_ENV === "production" ? (Rr.createRoot, Rr.hydrateRoot) : Rr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
//# sourceMappingURL=client-DHHkGJP0.mjs.map
